import React, { useState, useEffect } from 'react';
import { PerimeterImportPanel } from '../components/servicers/PerimeterImportPanel';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const STANDARD_FIELDS = [
  { value: 'id_proveedor', label: 'ID Proveedor' },
  { value: 'latitud', label: 'Latitud del inmueble' },
  { value: 'longitud', label: 'Longitud del inmueble' },
  { value: 'id_prestamo', label: 'ID Prestamo' },
  { value: 'id_finca', label: 'ID Finca' },
  { value: 'referencia_catastral', label: 'Referencia Catastral' },
  { value: 'direccion', label: 'Direccion' },
  { value: 'municipio', label: 'Municipio' },
  { value: 'provincia', label: 'Provincia' },
  { value: 'codigo_postal', label: 'Codigo Postal' },
  { value: 'tipo_activo', label: 'Tipo Inmueble' },
  { value: 'tipo_activo_operativo', label: 'Tipo Activo Operativo' },
  { value: 'metros', label: 'Metros' },
  { value: 'ocupacion', label: 'Ocupacion' },
  { value: 'posesion', label: 'Posesion' },
  { value: 'deuda_reclamada', label: 'Deuda Reclamada' },
  { value: 'deuda_total', label: 'Deuda Total' },
  { value: 'principal', label: 'Principal' },
  { value: 'intereses', label: 'Intereses' },
  { value: 'costas', label: 'Costas' },
  { value: 'valor_adjudicacion', label: 'Valor Adjudicacion' },
  { value: 'tasacion', label: 'Tasacion (o Valor Subasta)' },
  { value: 'valor_referencia', label: 'Valor de Referencia' },
  { value: 'valor_salida_base', label: 'Valor Salida Estimado' },
  { value: 'precio_compra', label: 'Precio Compra' },
  { value: 'estado_procesal', label: 'Estado Procesal' },
  { value: 'fase_judicial', label: 'Fase Judicial' },
  { value: 'fecha_subasta', label: 'Fecha Subasta' },
  { value: 'fecha_compra', label: 'Fecha Compra' },
  { value: 'vivienda_habitual', label: 'Vivienda Habitual' },
  { value: 'cargas', label: 'Cargas' },
  { value: 'ibi_pendiente', label: 'IBI Pendiente' },
  { value: 'comunidad_pendiente', label: 'Comunidad Pendiente' },
  { value: 'tiempo_resolucion_meses', label: 'Tiempo Resolucion (meses)' },
  { value: 'prioridad', label: 'Prioridad' },
  { value: 'observaciones_importacion', label: 'Observaciones' },
];
// 'estado' y 'fase' (comercial) son campos gestionados internamente por el
// flujo de trabajo (nunca se sobrescriben desde un Excel) y 'asignado_a' no
// es un campo del activo (pertenece a Mediación/Interacciones). No se
// ofrecen como destino de mapeo para evitar el error "no permitido" sin
// explicación visible en el selector.

const SUGGEST_MAP = {
  'id': 'id_proveedor', 'id_proveedor': 'id_proveedor', 'id proveedor': 'id_proveedor',
  'id_prestamo': 'id_prestamo', 'id prestamo': 'id_prestamo', 'prestamo': 'id_prestamo',
  'id_finca': 'id_finca', 'finca': 'id_finca',
  'ref_catastral': 'referencia_catastral', 'referencia': 'id_proveedor', 'catastral': 'referencia_catastral', 'referencia_catastral': 'referencia_catastral',
  'titulo': 'direccion', 'subestado': 'tipo_activo_operativo', 'latitud': 'latitud', 'longitud': 'longitud',
  'direccion': 'direccion', 'dir': 'direccion', 'domicilio': 'direccion', 'address': 'direccion',
  'municipio': 'municipio', 'ciudad': 'municipio', 'localidad': 'municipio', 'poblacion': 'municipio',
  'provincia': 'provincia', 'prov': 'provincia',
  'cp': 'codigo_postal', 'codigo_postal': 'codigo_postal', 'codigo postal': 'codigo_postal', 'postal': 'codigo_postal',
  'tipo_activo': 'tipo_activo', 'tipo activo': 'tipo_activo', 'tipo': 'tipo_activo', 'tipologia': 'tipo_activo',
  'tipo_operativo': 'tipo_activo_operativo', 'tipo activo operativo': 'tipo_activo_operativo', 'tipo_activo_operativo': 'tipo_activo_operativo', 'operativo': 'tipo_activo_operativo',
  'metros': 'metros', 'superficie': 'metros', 'm2': 'metros', 'metros_cuadrados': 'metros',
  'ocupacion': 'ocupacion', 'ocupado': 'ocupacion',
  'posesion': 'posesion',
  'deuda': 'deuda_reclamada', 'deuda_reclamada': 'deuda_reclamada', 'deuda reclamada': 'deuda_reclamada', 'deuda total': 'deuda_total', 'deuda_total': 'deuda_total',
  'principal': 'principal',
  'intereses': 'intereses',
  'costas': 'costas',
  'valor_subasta': 'tasacion', 'valor subasta': 'tasacion', 'subasta': 'tasacion',
  'adjudicacion': 'valor_adjudicacion', 'valor_adjudicacion': 'valor_adjudicacion',
  'tasacion': 'tasacion', 'valor_tasacion': 'tasacion',
  'valor_referencia': 'valor_referencia', 'valor referencia': 'valor_referencia',
  'valor_salida': 'valor_salida_base', 'valor salida': 'valor_salida_base', 'valor_venta': 'valor_salida_base',
  'precio': 'precio_compra', 'precio_compra': 'precio_compra', 'precio compra': 'precio_compra', 'coste': 'precio_compra',
  'estado_procesal': 'estado_procesal', 'estado procesal': 'estado_procesal',
  'fase_judicial': 'fase_judicial', 'fase judicial': 'fase_judicial',
  'fecha_subasta': 'fecha_subasta', 'fecha subasta': 'fecha_subasta',
  'fecha_compra': 'fecha_compra', 'fecha compra': 'fecha_compra',
  'vivienda_habitual': 'vivienda_habitual', 'vivienda habitual': 'vivienda_habitual',
  'cargas': 'cargas', 'carga': 'cargas',
  'ibi': 'ibi_pendiente', 'ibi_pendiente': 'ibi_pendiente',
  'comunidad': 'comunidad_pendiente', 'comunidad_pendiente': 'comunidad_pendiente',
  'meses': 'tiempo_resolucion_meses', 'tiempo': 'tiempo_resolucion_meses', 'tiempo_resolucion': 'tiempo_resolucion_meses', 'plazo': 'tiempo_resolucion_meses',
  'prioridad': 'prioridad',
  'observaciones': 'observaciones_importacion', 'notas': 'observaciones_importacion', 'comentarios': 'observaciones_importacion',
};

function suggestMapping(excelColumns) {
  const result = {};
  const used = new Set();
  for (const col of excelColumns) {
    const normalized = col.toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\s_-]+/g, '_');
    let match = SUGGEST_MAP[normalized];
    if (!match) {
      for (const [key, val] of Object.entries(SUGGEST_MAP)) {
        if (normalized.includes(key) || key.includes(normalized)) {
          if (!used.has(val)) { match = val; break; }
        }
      }
    }
    if (match && !used.has(match)) {
      result[col] = match;
      used.add(match);
    } else {
      result[col] = '';
    }
  }
  return result;
}

const ImporterPage = () => {
  const perimeterRef = React.useRef(null);
  const [step, setStep] = useState(1);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [mapping, setMapping] = useState({});
  const [proveedor, setProveedor] = useState('');
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [templateName, setTemplateName] = useState('');
  const [loading, setLoading] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [customFields, setCustomFields] = useState([]);
  const [creatingField, setCreatingField] = useState(null);
  const [tipoOperativo, setTipoOperativo] = useState(''); // column name being created
  const [enriching, setEnriching] = useState(false);
  const [enrichProgress, setEnrichProgress] = useState(null); // {processed, enriquecidos, pendientes}
  const [descuentoDeudaPct, setDescuentoDeudaPct] = useState(''); // global % de descuento sobre deuda
  const [selectedSheets, setSelectedSheets] = useState([]); // nombres de hojas a importar
  // Reconciliación: datos y decisiones por fila
  const [reconcileData, setReconcileData] = useState(null); // {enabled, total_rows, new_count, duplicate_count, conflicts[]}
  const [reconcileDecisions, setReconcileDecisions] = useState({}); // {global_idx: {action, existing_id, overrides}}
  const [showReconcile, setShowReconcile] = useState(false);
  const [reconciling, setReconciling] = useState(false);
  // Fase Judicial alias mapper: when the Excel column mapped to fase_judicial
  // contains values our normaliser can't map to any canonical enum, we ask
  // the user to assign them before importing.
  const [fjScan, setFjScan] = useState(null); // {recognised, unrecognised, mapped_column}
  const [fjDecisions, setFjDecisions] = useState({}); // {raw_value: canonical_or_skip}
  const [showFjMapper, setShowFjMapper] = useState(false);
  const [scanningFj, setScanningFj] = useState(false);

  // Preflight smart-check: scans the entire Excel and reports rows that
  // will require manual fields after import (precio_compra, tipo_operativo,
  // deuda). Recomputed automatically whenever the user changes the mapping
  // or the selected sheets so the warning panel stays in sync.
  const [preflight, setPreflight] = useState(null); // {total_rows, missing_precio_compra, missing_tipo_operativo, missing_deuda}
  const [preflightLoading, setPreflightLoading] = useState(false);
  const [preflightConfirmed, setPreflightConfirmed] = useState(false); // user accepted to import despite warnings
  const [showPreflightModal, setShowPreflightModal] = useState(false);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/mapping-templates`, { withCredentials: true }).catch(() => ({ data: [] })),
      axios.get(`${API}/custom-fields`, { withCredentials: true }).catch(() => ({ data: [] })),
    ]).then(([tplRes, cfRes]) => {
      setTemplates(tplRes.data.items ?? tplRes.data);
      setCustomFields(cfRes.data.items ?? cfRes.data);
    });
  }, []);

  // Run preflight checks every time the user changes the mapping or sheet
  // selection. Debounced 500ms so quick mapping clicks don't flood the API.
  useEffect(() => {
    if (!file || !preview) {
      setPreflight(null);
      return;
    }
    const mapped = Object.values(mapping).filter(Boolean);
    if (mapped.length === 0) {
      setPreflight(null);
      return;
    }
    const t = setTimeout(async () => {
      setPreflightLoading(true);
      try {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('mapping', JSON.stringify(mapping));
        if (preview?.sheets && preview.sheets.length > 0) {
          fd.append('sheet_names', JSON.stringify(selectedSheets));
        }
        const r = await axios.post(`${API}/import/preflight-checks`, fd, {
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 60000,
        });
        setPreflight(r.data);
        // Any change in mapping/sheets invalidates the previous "I accept" decision.
        setPreflightConfirmed(false);
      } catch (e) {
        console.warn('preflight error', e);
        setPreflight(null);
      } finally {
        setPreflightLoading(false);
      }
    }, 500);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapping, selectedSheets, file]);

  const handleFileSelect = async (selectedFile) => {
    if (!selectedFile) return;
    const ext = selectedFile.name.toLowerCase().split('.').pop();
    if (!['xlsx', 'xls', 'csv'].includes(ext)) {
      toast.error('Formato no soportado. Usa .xlsx, .xls o .csv');
      return;
    }
    setFile(selectedFile);
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', selectedFile);
      const res = await axios.post(`${API}/import/preview`, formData, { withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' } });
      setPreview(res.data);
      // Por defecto seleccionar TODAS las hojas (evita que el usuario se olvide)
      const sheetList = (res.data.sheets || []).map(s => s.name);
      setSelectedSheets(sheetList);
      const suggested = suggestMapping(res.data.columns);
      setMapping(suggested);
      const suggestedCount = Object.values(suggested).filter(v => v).length;
      if (suggestedCount > 0) {
        toast.success(`${suggestedCount} columnas mapeadas automaticamente`);
      }
      setStep(2);
    } catch (err) {
      toast.error('Error al leer archivo: ' + (err.response?.data?.detail || err.message));
      setFile(null);
    } finally {
      setLoading(false);
    }
  };

  const handleTemplateSelect = (templateId) => {
    setSelectedTemplate(templateId);
    if (!templateId) return;
    const tpl = templates.find(t => t.id === templateId);
    if (tpl) {
      setProveedor(tpl.proveedor);
      const newMap = { ...mapping };
      Object.keys(tpl.mapping).forEach(col => {
        if (col in newMap) newMap[col] = tpl.mapping[col];
      });
      setMapping(newMap);
      toast.success('Plantilla aplicada');
    }
  };

  const handleSaveTemplate = async () => {
    if (!templateName || !proveedor) { toast.error('Nombre y proveedor requeridos'); return; }
    try {
      await axios.post(`${API}/mapping-templates`, { nombre: templateName, proveedor, mapping }, { withCredentials: true });
      toast.success('Plantilla guardada');
      setTemplateName('');
      const res = await axios.get(`${API}/mapping-templates`, { withCredentials: true });
      setTemplates(res.data.items ?? res.data);
    } catch { toast.error('Error al guardar plantilla'); }
  };

  const handleImport = async () => {
    if (perimeterRef.current) { await perimeterRef.current.preview(); return; }
    if (!proveedor) { toast.error('Introduce el proveedor'); return; }
    if (!hasTipoMapped && !tipoOperativo) { toast.error('Selecciona el tipo de operacion'); return; }
    if (preview?.sheets && preview.sheets.length > 0 && selectedSheets.length === 0) {
      toast.error('Selecciona al menos una pestaña a importar');
      return;
    }
    // Smart pre-import block: if >50% of the rows will land with critical
    // fields missing AND the user has not provided a global override
    // (% descuento / tipo global), force them to acknowledge before
    // continuing. They can still proceed but at least know what they're doing.
    if (preflight && !preflightConfirmed) {
      const total = preflight.total_rows || 0;
      const blockers = [];
      if (total > 0 && preflight.missing_precio_compra.count / total > 0.5 && !descuentoDeudaPct) {
        blockers.push('precio');
      }
      if (total > 0 && preflight.missing_tipo_operativo.count / total > 0.5 && !tipoOperativo) {
        blockers.push('tipo');
      }
      if (blockers.length > 0) {
        setShowPreflightModal(true);
        return;
      }
    }
    // Step 2.4: si la fase_judicial está mapeada, escanear los valores únicos
    // y pedir al usuario que mapee los que el normaliser no reconoce.
    const fjMapped = Object.values(mapping).includes('fase_judicial') || Object.values(mapping).includes('estado_procesal');
    if (fjMapped && !showFjMapper && !fjScan) {
      setScanningFj(true);
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('mapping', JSON.stringify(mapping));
        if (preview?.sheets && preview.sheets.length > 0) {
          formData.append('sheet_names', JSON.stringify(selectedSheets));
        }
        const r = await axios.post(`${API}/import/scan-fase-judicial`, formData, { withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 });
        setFjScan(r.data);
        if (r.data.unrecognised && r.data.unrecognised.length > 0) {
          // Pre-fill decisions with empty mapping so user picks each one
          const dec = {};
          r.data.unrecognised.forEach(v => { dec[v] = ''; });
          setFjDecisions(dec);
          setShowFjMapper(true);
          setScanningFj(false);
          return;
        }
      } catch (err) {
        console.warn('scan fase_judicial error:', err);
      } finally {
        setScanningFj(false);
      }
    }
    // Step 2.5: reconciliación. Solo tiene sentido si hay RC mapeada.
    const rcMapped = Object.values(mapping).includes('referencia_catastral');
    if (rcMapped && !showReconcile) {
      setReconciling(true);
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('mapping', JSON.stringify(mapping));
        if (preview?.sheets && preview.sheets.length > 0) {
          formData.append('sheet_names', JSON.stringify(selectedSheets));
        }
        const r = await axios.post(`${API}/import/reconcile`, formData, { withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 });
        setReconcileData(r.data);
        // Genera decisions "skip" para las filas auto-saltadas (sin cambios o
        // solo cambios de catastro). Se aplican en execute aunque no se
        // muestre la pantalla de reconciliación.
        const autoSkipDecisions = {};
        for (const idx of (r.data.auto_skipped_indices || [])) {
          autoSkipDecisions[idx] = { action: 'skip' };
        }
        if (r.data.enabled && r.data.duplicate_count > 0) {
          // Default: todas las filas en conflicto se fusionan como deuda, sin override de campos
          const defaults = { ...autoSkipDecisions };
          for (const c of r.data.conflicts) {
            defaults[c.global_idx] = {
              action: 'merge',
              existing_id: c.existing.id,
              overrides: {},
            };
          }
          setReconcileDecisions(defaults);
          setShowReconcile(true);
          setReconciling(false);
          return;
        }
        // Sin conflictos que decidir manualmente, pero puede haber auto-skips
        // que hay que pasar a execute.
        if (Object.keys(autoSkipDecisions).length > 0) {
          setReconcileDecisions(autoSkipDecisions);
          await doImport(autoSkipDecisions);
          setReconciling(false);
          return;
        }
      } catch (err) {
        // Si reconcile falla continuamos con el flujo clásico
        console.warn('reconcile error:', err);
      } finally {
        setReconciling(false);
      }
    }
    await doImport(reconcileDecisions);
  };

  const confirmFjMapping = async () => {
    // Save aliases for every value the user chose to map (skip empty ones)
    const toSave = Object.entries(fjDecisions).filter(([_k, v]) => v && v !== 'skip');
    if (toSave.length > 0) {
      try {
        await Promise.all(toSave.map(([alias, canonical]) =>
          axios.post(`${API}/fase-judicial/aliases`, { alias, canonical }, { withCredentials: true })
        ));
        toast.success(`${toSave.length} alias guardado${toSave.length > 1 ? 's' : ''}`);
      } catch (err) {
        toast.error('Error guardando alias: ' + (err.response?.data?.detail || err.message));
        return;
      }
    }
    setShowFjMapper(false);
    // Now resume the import flow (reconcile + execute)
    handleImport();
  };

  const skipFjMapping = () => {
    // User chose to ignore unrecognised fase_judicial values: they'll be
    // stored as null on the imported assets. Continue the import.
    setShowFjMapper(false);
    handleImport();
  };

  const doImport = async (decisions) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('mapping', JSON.stringify(mapping));
      formData.append('proveedor', proveedor);
      formData.append('enrich_catastro', 'false');
      if (descuentoDeudaPct !== '' && !isNaN(parseFloat(descuentoDeudaPct))) {
        formData.append('descuento_deuda_pct', String(parseFloat(descuentoDeudaPct)));
      }
      if (!hasTipoMapped && tipoOperativo) {
        formData.append('tipo_activo_operativo', tipoOperativo);
      }
      if (preview?.sheets && preview.sheets.length > 0) {
        formData.append('sheet_names', JSON.stringify(selectedSheets));
      }
      if (decisions && Object.keys(decisions).length > 0) {
        formData.append('reconciliation', JSON.stringify(decisions));
      }
      const res = await axios.post(`${API}/import/execute`, formData, { withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' }, timeout: 180000 });
      setImportResult(res.data);
      setShowReconcile(false);
      setStep(3);
      const msg = [
        res.data.imported ? `${res.data.imported} activos creados` : null,
        res.data.merged ? `${res.data.merged} deudas fusionadas` : null,
        res.data.autofilled_fields ? `${res.data.autofilled_fields} campos vacíos rellenados en ${res.data.autofilled_assets} activos` : null,
        res.data.skipped ? `${res.data.skipped} filas saltadas` : null,
      ].filter(Boolean).join(' · ');
      toast.success(msg || `${res.data.imported || 0} activos importados`);
    } catch (err) {
      toast.error('Error: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const runEnrichPending = async () => {
    setEnriching(true);
    setEnrichProgress({ processed: 0, enriquecidos: 0, pendientes: null });
    try {
      let totalProcessed = 0;
      let totalEnriched = 0;
      let pending = Infinity;
      // Enrich in batches of 30 until no pending assets remain (cap 100 batches ≈ 3k).
      for (let i = 0; i < 100 && pending !== 0; i++) {
        const r = await axios.post(`${API}/assets/enrich-catastro-missing?limit=30`, {}, { withCredentials: true, timeout: 60000 });
        totalProcessed += r.data.processed || 0;
        totalEnriched += r.data.enriquecidos || 0;
        pending = r.data.pendientes || 0;
        setEnrichProgress({ processed: totalProcessed, enriquecidos: totalEnriched, pendientes: pending });
        if (r.data.processed === 0) break;
      }
      toast.success(`Enriquecimiento completado: ${totalEnriched} metros completados`);
    } catch (err) {
      toast.error('Error: ' + (err.response?.data?.detail || err.message));
    } finally { setEnriching(false); }
  };

  // Quick-create a custom field from an Excel column name
  const handleCreateFieldFromColumn = async (excelCol) => {
    setCreatingField(excelCol);
    const cleanName = excelCol.toLowerCase().trim()
      .replace(/[^a-z0-9\s]/gi, '')
      .replace(/\s+/g, '_');
    
    try {
      const res = await axios.post(`${API}/custom-fields`, {
        name: cleanName,
        label: excelCol,
        field_type: 'texto',
      }, { withCredentials: true });

      setCustomFields(prev => [...prev, res.data]);
      setMapping(prev => ({ ...prev, [excelCol]: res.data.name }));
      toast.success(`Campo "${excelCol}" creado y mapeado`);
    } catch (err) {
      const detail = err.response?.data?.detail || '';
      if (detail.includes('Ya existe')) {
        // Field already exists, just find and map it
        const existing = customFields.find(cf => cf.label === excelCol || cf.name === `custom_${cleanName}`);
        if (existing) {
          setMapping(prev => ({ ...prev, [excelCol]: existing.name }));
          toast.success(`Campo existente "${existing.label}" mapeado`);
        } else {
          toast.error(detail);
        }
      } else {
        toast.error('Error al crear campo: ' + detail);
      }
    } finally {
      setCreatingField(null);
    }
  };

  const reset = () => {
    setStep(1); setFile(null); setPreview(null); setMapping({});
    setProveedor(''); setImportResult(null); setTipoOperativo('');
  };

  const mappedCount = Object.values(mapping).filter(v => v && v !== 'none').length;
  const hasTipoMapped = Object.values(mapping).includes('tipo_activo_operativo');

  // Detecta campos destino asignados a más de una columna de origen a la
  // vez. El backend rechaza esto como "Mapeo duplicado o no permitido" sin
  // que el usuario viera antes ninguna marca visual del conflicto; aquí lo
  // resaltamos en rojo fila por fila ANTES de enviar, con el nombre exacto
  // del campo y las columnas implicadas, para que pueda corregirlo al vuelo.
  const fieldLabel = React.useCallback((value) => {
    const std = STANDARD_FIELDS.find(f => f.value === value);
    if (std) return std.label;
    const custom = customFields.find(cf => cf.name === value);
    return custom ? custom.label : value;
  }, [customFields]);
  const duplicateTargets = React.useMemo(() => {
    const byField = {};
    Object.entries(mapping).forEach(([col, field]) => {
      if (!field || field === 'none') return;
      (byField[field] ||= []).push(col);
    });
    return Object.fromEntries(Object.entries(byField).filter(([, cols]) => cols.length > 1));
  }, [mapping]);
  const hasDuplicateMapping = Object.keys(duplicateTargets).length > 0;

  return (
    <div className="space-y-6 min-w-0" data-testid="importer-page">
      <div>
        <h1 className="heading-1">Importar Excel</h1>
        <p className="body-text mt-1">Sube y mapea tus listados de activos</p>
      </div>

      {/* Progress */}
      <div className="flex items-center gap-2">
        {[1, 2, 3].map(s => (
          <React.Fragment key={s}>
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${step >= s ? 'bg-blue-600 text-white' : 'bg-slate-200 text-slate-400'}`}>
              {step > s ? '\u2713' : s}
            </div>
            {s < 3 && <div className={`flex-1 h-1 rounded ${step > s ? 'bg-blue-600' : 'bg-slate-200'}`} />}
          </React.Fragment>
        ))}
      </div>

      {/* Step 1: Upload */}
      {step === 1 && (
        <div className="card-base p-8">
          <div className="border-2 border-dashed border-slate-300 rounded-xl p-12 text-center hover:bg-slate-50 transition-colors">
            {loading ? (
              <p className="text-blue-600 font-medium">Procesando archivo...</p>
            ) : (
              <>
                <p className="text-lg font-medium text-slate-700 mb-2">Arrastra tu archivo aqui o haz clic</p>
                <p className="text-sm text-slate-500 mb-4">Formatos: .xlsx, .xls, .csv</p>
                <input type="file" accept=".xlsx,.xls,.csv" onChange={e => handleFileSelect(e.target.files[0])} className="block mx-auto text-sm" data-testid="file-input" />
              </>
            )}
          </div>
        </div>
      )}

      {/* Step 2: Mapping */}
      {step === 2 && preview && !showReconcile && (
        <div className="space-y-6">
          {/* File info */}
          <div className="card-base p-4 flex items-center justify-between">
            <div>
              <p className="font-medium">{file.name}</p>
              <p className="text-sm text-slate-500">
                {preview.total_rows} filas totales &middot; {preview.columns.length} columnas
                {preview.sheets && preview.sheets.length > 1 && (
                  <> &middot; <span className="font-medium text-blue-600">{preview.sheets.length} pestañas</span></>
                )}
              </p>
            </div>
            <button onClick={reset} className="btn-secondary text-sm" data-testid="change-file-btn">Cambiar archivo</button>
          </div>

          {/* Multi-sheet selector — solo si hay >1 hoja */}
          <PerimeterImportPanel ref={perimeterRef} file={file} mapping={mapping} sheets={selectedSheets} provider={proveedor} discount={descuentoDeudaPct} disabled={hasDuplicateMapping} />
          {preview.sheets && preview.sheets.length > 1 && (
            <div className="card-base p-6" data-testid="sheet-selector">
              <div className="flex items-start justify-between gap-4 mb-3">
                <div>
                  <h3 className="heading-3">Pestañas a importar</h3>
                  <p className="text-sm text-slate-500 mt-1">
                    Tu Excel tiene {preview.sheets.length} pestañas. Marca cuáles quieres importar. Las filas se concatenan todas.
                  </p>
                </div>
                <div className="flex gap-2 shrink-0">
                  <button
                    type="button"
                    onClick={() => setSelectedSheets(preview.sheets.map(s => s.name))}
                    className="btn-secondary text-xs"
                    data-testid="sheets-select-all"
                  >Todas</button>
                  <button
                    type="button"
                    onClick={() => setSelectedSheets([])}
                    className="btn-secondary text-xs"
                    data-testid="sheets-select-none"
                  >Ninguna</button>
                </div>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
                {preview.sheets.map(s => {
                  const checked = selectedSheets.includes(s.name);
                  return (
                    <label
                      key={s.name}
                      className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
                        checked ? 'border-blue-500 bg-blue-50' : 'border-slate-200 hover:border-slate-300'
                      }`}
                      data-testid={`sheet-row-${s.name}`}
                    >
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => {
                          setSelectedSheets(prev => prev.includes(s.name)
                            ? prev.filter(x => x !== s.name)
                            : [...prev, s.name]);
                        }}
                        className="w-4 h-4 accent-blue-600"
                      />
                      <div className="min-w-0 flex-1">
                        <div className="font-medium truncate">{s.name}</div>
                        <div className="text-xs text-slate-500">{s.total_rows} filas &middot; {s.columns.length} columnas</div>
                      </div>
                    </label>
                  );
                })}
              </div>
              <p className="text-xs text-slate-500 mt-3">
                Seleccionadas: <span className="font-medium text-slate-700">{selectedSheets.length}</span> · Filas a importar: <span className="font-medium text-slate-700">{preview.sheets.filter(s => selectedSheets.includes(s.name)).reduce((acc, s) => acc + s.total_rows, 0)}</span>
              </p>
            </div>
          )}

          {/* Config */}
          <div className="card-base p-6">
            <h3 className="heading-3 mb-4">Configuracion</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="space-y-1">
                <label className="text-sm text-slate-600">Proveedor *</label>
                <input className="input-base" value={proveedor} onChange={e => setProveedor(e.target.value)} placeholder="Nombre del proveedor" data-testid="proveedor-input" />
              </div>
              <div className="space-y-1">
                <label className="text-sm text-slate-600">Aplicar plantilla</label>
                <select className="input-base" value={selectedTemplate} onChange={e => handleTemplateSelect(e.target.value)} data-testid="template-select">
                  <option value="">Sin plantilla</option>
                  {templates.map(t => <option key={t.id} value={t.id}>{t.nombre} ({t.proveedor})</option>)}
                </select>
              </div>
            </div>
            {!hasTipoMapped && (
              <div className="mt-4 p-4 bg-amber-50 border border-amber-200 rounded-lg">
                <label className="text-sm font-medium text-amber-800 block mb-2">Tipo de operacion *</label>
                <p className="text-xs text-amber-600 mb-2">El Excel no incluye tipo de operacion. Selecciona el tipo para todos los activos de esta importacion.</p>
                <select className="input-base w-64" value={tipoOperativo} onChange={e => setTipoOperativo(e.target.value)} data-testid="tipo-operativo-select">
                  <option value="">Seleccionar tipo...</option>
                  <option value="COMPRA_DIRECTA">Compra Directa</option>
                  <option value="SUBASTA">Subasta</option>
                  <option value="CREDITO">Credito</option>
                  <option value="REMATE">Remate</option>
                  <option value="OCUPADO">Ocupado</option>
                  <option value="REO">REO</option>
                </select>
              </div>
            )}

            {/* Precio Compra Estimado — aplica un % global a filas sin precio_compra */}
            <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <label className="text-sm font-medium text-blue-900 block mb-2">
                % de Descuento sobre Deuda (global)
              </label>
              <p className="text-xs text-blue-700 mb-2">
                Se aplica únicamente a los activos que no traen <strong>Precio de Compra</strong> en el Excel.
                Fórmula: <code>Precio Compra Estimado = Deuda × (1 − % Descuento)</code>. Ejemplo: 30% sobre 100.000 € → 70.000 €.
              </p>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  min="0"
                  max="100"
                  step="0.1"
                  className="input-base w-32"
                  value={descuentoDeudaPct}
                  onChange={e => setDescuentoDeudaPct(e.target.value)}
                  placeholder="Ej: 30"
                  data-testid="descuento-deuda-pct-input"
                />
                <span className="text-sm text-blue-900 font-medium">%</span>
                <span className="text-xs text-slate-500 ml-3">
                  (Opcional — si lo dejas vacío, los activos sin precio quedarán a 0 €)
                </span>
              </div>
            </div>
          </div>

          {/* Column Mapping */}
          <div className="card-base p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="heading-3">Mapeo de Columnas</h3>
              <span className="text-xs text-slate-400">{mappedCount} de {preview.columns.length} mapeadas</span>
            </div>

            {hasDuplicateMapping && (
              <div className="mb-4 p-3 rounded-lg border border-red-300 bg-red-50 text-sm text-red-700" data-testid="duplicate-mapping-banner">
                <p className="font-semibold">Mapeo duplicado: un mismo campo no puede recibir datos de varias columnas.</p>
                <ul className="list-disc list-inside mt-1 space-y-0.5">
                  {Object.entries(duplicateTargets).map(([field, cols]) => (
                    <li key={field}>
                      <strong>{fieldLabel(field)}</strong> está asignado a: {cols.join(', ')}. Cambia el destino de todas menos una.
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="space-y-2 max-h-[500px] overflow-y-auto overflow-x-hidden pr-1">
              {preview.columns.map(col => {
                const mapped = mapping[col] && mapping[col] !== 'none';
                const isCreating = creatingField === col;
                const isDuplicate = mapped && !!duplicateTargets[mapping[col]];
                return (
                  <div
                    key={col}
                    className={`flex items-center gap-3 p-3 rounded-lg border transition-colors ${
                      isDuplicate ? 'bg-red-50 border-red-300' : mapped ? 'bg-blue-50/50 border-blue-200' : 'bg-slate-50 border-slate-200'
                    }`}
                    data-testid={`mapping-row-${col}`}
                  >
                    {/* Source column name + preview */}
                    <div className="min-w-0 w-[240px] shrink-0">
                      <p className="font-semibold text-slate-800 text-sm truncate" title={col}>{col || '(sin nombre)'}</p>
                      {preview.preview[0] && (
                        <p className="text-xs text-slate-400 truncate mt-0.5" title={String(preview.preview[0][col] ?? '')}>
                          Ej: {String(preview.preview[0][col] ?? '-').slice(0, 50)}
                        </p>
                      )}
                    </div>

                    {/* Arrow */}
                    <span className={`shrink-0 text-sm ${isDuplicate ? 'text-red-400' : mapped ? 'text-blue-400' : 'text-slate-300'}`}>&rarr;</span>

                    <div className="shrink-0" style={{ width: '220px', minWidth: '220px' }}>
                      {/* Destination select */}
                      <select
                        className={`w-full rounded-lg border bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 transition-all ${
                          isDuplicate ? 'border-red-400 focus:ring-red-500/20 focus:border-red-500' : mapped ? 'border-blue-300 focus:ring-blue-500/20 focus:border-blue-500' : 'border-slate-200 focus:ring-blue-500/20 focus:border-blue-500'
                        }`}
                        value={mapping[col] || 'none'}
                        onChange={e => setMapping({ ...mapping, [col]: e.target.value === 'none' ? '' : e.target.value })}
                        data-testid={`mapping-${col}`}
                      >
                        <option value="none">-- No mapear --</option>
                        <optgroup label="Campos estandar">
                          {STANDARD_FIELDS.map(f => (
                            <option key={f.value} value={f.value}>{f.label}</option>
                          ))}
                        </optgroup>
                        {customFields.length > 0 && (
                          <optgroup label="Campos personalizados">
                            {customFields.map(cf => (
                              <option key={cf.name} value={cf.name}>{cf.label}</option>
                            ))}
                          </optgroup>
                        )}
                      </select>
                      {isDuplicate && (
                        <p className="text-xs text-red-600 mt-1" data-testid={`mapping-duplicate-error-${col}`}>
                          Duplicado: otra columna también usa "{fieldLabel(mapping[col])}"
                        </p>
                      )}
                    </div>

                    {/* Quick-create button for unmapped columns */}
                    {!mapped && (
                      <button
                        onClick={() => handleCreateFieldFromColumn(col)}
                        disabled={isCreating}
                        className="shrink-0 text-xs font-medium text-blue-600 hover:text-blue-800 border border-blue-200 rounded-md px-2.5 py-1.5 hover:bg-blue-50 transition-colors whitespace-nowrap disabled:opacity-50"
                        title={`Crear campo "${col}" y mapearlo`}
                        data-testid={`create-for-${col}`}
                      >
                        {isCreating ? 'Creando...' : 'Crear campo'}
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Save as template */}
          <div className="card-base p-6">
            <h3 className="heading-3 mb-4">Guardar como plantilla</h3>
            <div className="flex gap-3">
              <input className="input-base flex-1" value={templateName} onChange={e => setTemplateName(e.target.value)} placeholder="Nombre de la plantilla" data-testid="template-name-input" />
              <button onClick={handleSaveTemplate} disabled={!templateName || !proveedor} className="btn-secondary" data-testid="save-template-btn">Guardar plantilla</button>
            </div>
          </div>

          {/* Data Preview - forced horizontal scroll with readable columns */}
          <div className="card-base" style={{ padding: 0 }}>
            <div className="p-6 pb-3">
              <h3 className="heading-3">Vista previa de datos ({preview.total_rows} filas)</h3>
              <p className="text-xs text-slate-400 mt-1">Scroll horizontal para ver todas las columnas</p>
            </div>
            <div className="border-t border-slate-200">
              <div
                style={{
                  overflowX: 'scroll',
                  overflowY: 'auto',
                  maxHeight: '360px',
                  maxWidth: '100%',
                }}
                data-testid="preview-table-container"
              >
                <table
                  style={{
                    width: `${preview.columns.length * 200}px`,
                    tableLayout: 'fixed',
                    borderCollapse: 'collapse',
                  }}
                >
                <colgroup>
                  {preview.columns.map(c => (
                    <col key={c} style={{ width: '200px', minWidth: '200px' }} />
                  ))}
                </colgroup>
                <thead>
                  <tr style={{ position: 'sticky', top: 0, zIndex: 2 }} className="bg-slate-100">
                    {preview.columns.map(c => (
                      <th
                        key={c}
                        className="text-left text-xs font-semibold text-slate-600 uppercase tracking-wide border-b border-r border-slate-200 bg-slate-100"
                        style={{ padding: '10px 16px', width: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        title={c}
                      >
                        {c}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {preview.preview.slice(0, 5).map((r, i) => (
                    <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-slate-50/50'}>
                      {preview.columns.map(c => (
                        <td
                          key={c}
                          className="text-sm text-slate-700 border-b border-r border-slate-100"
                          style={{ padding: '8px 16px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                          title={String(r[c] ?? '')}
                        >
                          {String(r[c] ?? '-')}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
            </div>
          </div>

          {/* Smart preflight checks — detecta filas que requerirán datos
               manuales tras importar (precio_compra, tipo_operativo, deuda).
               Solo se muestra si hay alguna alerta accionable; cuando todo
               está limpio se muestra un check verde compacto. */}
          {preflight && (preflight.missing_precio_compra.count > 0
            || preflight.missing_tipo_operativo.count > 0
            || preflight.missing_deuda.count > 0) ? (
            <div className="card-base p-5 border-l-4 border-amber-400 bg-amber-50/40" data-testid="preflight-panel">
              <div className="flex items-center gap-2 mb-3">
                <span className="text-amber-500 text-lg">⚠️</span>
                <h3 className="heading-3 text-amber-900">Comprobación previa al import</h3>
                {preflightLoading && <span className="text-xs text-slate-500">(actualizando...)</span>}
              </div>
              <p className="text-xs text-slate-600 mb-4">
                Antes de importar, revisa estos puntos. Si los dejas sin resolver, los activos se crearán igualmente pero con campos vacíos que tendrás que rellenar a mano después.
              </p>
              <div className="space-y-3">
                {preflight.missing_precio_compra.count > 0 && (
                  <div className="flex items-start gap-3 p-3 bg-white border border-amber-200 rounded-md" data-testid="preflight-precio">
                    <span className="text-amber-500 text-xl shrink-0">💰</span>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-slate-800">
                        {preflight.missing_precio_compra.count} {preflight.missing_precio_compra.count === 1 ? 'fila' : 'filas'} sin <span className="font-mono">Precio de Compra</span>
                      </p>
                      <p className="text-xs text-slate-600 mt-1">
                        {descuentoDeudaPct
                          ? <>Aplicaré el <strong>{descuentoDeudaPct}% de descuento</strong> sobre la deuda para calcular el precio estimado. ✓</>
                          : <>Si no rellenas el campo <strong>"% de Descuento sobre Deuda"</strong> (caja azul arriba), estos activos quedarán con precio = 0 y sin Score.</>
                        }
                      </p>
                      {preflight.missing_precio_compra.sample.length > 0 && (
                        <p className="text-xs text-slate-400 mt-1">
                          Ejemplos: <span className="font-mono">{preflight.missing_precio_compra.sample.join(', ')}</span>
                          {preflight.missing_precio_compra.count > 5 && '...'}
                        </p>
                      )}
                    </div>
                  </div>
                )}
                {preflight.missing_tipo_operativo.count > 0 && (
                  <div className="flex items-start gap-3 p-3 bg-white border border-amber-200 rounded-md" data-testid="preflight-tipo">
                    <span className="text-amber-500 text-xl shrink-0">🏷️</span>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-slate-800">
                        {preflight.missing_tipo_operativo.count} {preflight.missing_tipo_operativo.count === 1 ? 'fila' : 'filas'} sin <span className="font-mono">Tipo de Operación</span>
                      </p>
                      <p className="text-xs text-slate-600 mt-1">
                        {tipoOperativo
                          ? <>Aplicaré <strong>{tipoOperativo}</strong> como tipo por defecto a todas. ✓</>
                          : !hasTipoMapped
                            ? <>El Excel no incluye esta columna. <strong>Selecciona un tipo en la caja ámbar de arriba</strong> para aplicarlo a todas.</>
                            : <>La columna está mapeada pero algunas filas vienen vacías. Esos activos se crearán sin tipo (no entrarán en filtros ni cálculos por tipo).</>
                        }
                      </p>
                      {preflight.missing_tipo_operativo.sample.length > 0 && (
                        <p className="text-xs text-slate-400 mt-1">
                          Ejemplos: <span className="font-mono">{preflight.missing_tipo_operativo.sample.join(', ')}</span>
                          {preflight.missing_tipo_operativo.count > 5 && '...'}
                        </p>
                      )}
                    </div>
                  </div>
                )}
                {preflight.missing_deuda.count > 0 && (
                  <div className="flex items-start gap-3 p-3 bg-white border border-amber-200 rounded-md" data-testid="preflight-deuda">
                    <span className="text-amber-500 text-xl shrink-0">📉</span>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-slate-800">
                        {preflight.missing_deuda.count} {preflight.missing_deuda.count === 1 ? 'fila' : 'filas'} sin <span className="font-mono">Deuda</span> (ni total ni reclamada)
                      </p>
                      <p className="text-xs text-slate-600 mt-1">
                        En estas filas el <strong>% de Descuento</strong> no podrá aplicarse (deuda × X = 0). Si tampoco traen Precio de Compra, se quedarán a 0.
                      </p>
                      {preflight.missing_deuda.sample.length > 0 && (
                        <p className="text-xs text-slate-400 mt-1">
                          Ejemplos: <span className="font-mono">{preflight.missing_deuda.sample.join(', ')}</span>
                          {preflight.missing_deuda.count > 5 && '...'}
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : preflight && preflight.total_rows > 0 ? (
            <div className="card-base p-3 border-l-4 border-emerald-400 bg-emerald-50/40 flex items-center gap-2" data-testid="preflight-panel-ok">
              <span className="text-emerald-500 text-lg">✓</span>
              <p className="text-sm text-emerald-800">
                <strong>Todo listo:</strong> las {preflight.total_rows} filas tienen Precio, Tipo de Operación y Deuda. No se requerirá trabajo manual posterior.
              </p>
            </div>
          ) : null}

          {/* Actions */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <p className="text-xs text-slate-500">
              💡 El enriquecimiento desde Catastro se hace ahora desde <strong>Base de Activos</strong> con selección múltiple y la acción <strong>SOLICITAR DATOS A CATASTRO</strong> (filtro "sin m²").
            </p>
            <div className="flex gap-3">
              <button onClick={reset} className="btn-secondary" data-testid="cancel-btn">Cancelar</button>
              <button
                onClick={handleImport}
                disabled={loading || reconciling || scanningFj || hasDuplicateMapping}
                className="btn-primary"
                title={hasDuplicateMapping ? 'Corrige el mapeo duplicado señalado en rojo antes de continuar' : undefined}
                data-testid="import-btn"
              >
                Previsualizar importación
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Step 2.5: Reconciliation — detecta duplicados por RC y deja decidir por fila */}
      {step === 2 && showReconcile && reconcileData && (
        <ReconciliationPanel
          data={reconcileData}
          decisions={reconcileDecisions}
          setDecisions={setReconcileDecisions}
          onBack={() => setShowReconcile(false)}
          onConfirm={() => doImport(reconcileDecisions)}
          loading={loading}
        />
      )}

      {/* Step 2.4: Fase Judicial alias mapper */}
      {showFjMapper && fjScan && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid="fj-mapper-modal">
          <div className="rounded-xl shadow-xl max-w-3xl w-full p-6 space-y-4 max-h-[85vh] overflow-y-auto" style={{ background: 'var(--color-bg-secondary)', border: '1px solid var(--color-border)', color: 'var(--color-text-primary)' }}>
            <div>
              <h3 className="text-lg font-semibold">Mapear Fase Judicial</h3>
              <p className="text-sm mt-1" style={{ color: 'var(--color-text-muted)' }}>
                Tu Excel contiene <strong>{fjScan.unrecognised.length}</strong> valores en la columna "{fjScan.mapped_column}" que no coinciden con ninguna fase judicial conocida. Asígnalos a una fase canónica o sáltalos (los activos quedarán con fase judicial vacía). Los mapeos se guardan como aliases para futuras importaciones.
              </p>
            </div>
            <div className="rounded-lg border" style={{ borderColor: 'var(--color-border)' }}>
              <table className="w-full text-sm">
                <thead className="text-xs uppercase tracking-wide" style={{ background: 'var(--color-bg-elevated)', color: 'var(--color-text-muted)' }}>
                  <tr>
                    <th className="px-3 py-2 text-left">Valor en Excel</th>
                    <th className="px-3 py-2 text-left">Mapear a fase judicial</th>
                  </tr>
                </thead>
                <tbody>
                  {fjScan.unrecognised.map(raw => (
                    <tr key={raw} className="border-t" style={{ borderColor: 'var(--color-border)' }} data-testid={`fj-mapper-row-${raw}`}>
                      <td className="px-3 py-2 text-xs font-mono" style={{ color: 'var(--color-text-primary)' }}>{raw}</td>
                      <td className="px-3 py-2">
                        <select
                          value={fjDecisions[raw] || ''}
                          onChange={e => setFjDecisions(prev => ({ ...prev, [raw]: e.target.value }))}
                          className="input-base text-xs"
                          data-testid={`fj-mapper-select-${raw}`}
                        >
                          <option value="">— sin mapear (saltar) —</option>
                          {[
                            { v: 'sin_iniciar', l: 'Sin iniciar' },
                            { v: 'demanda_presentada', l: 'Demanda presentada' },
                            { v: 'auto_admision', l: 'Auto de admisión' },
                            { v: 'certificacion_registral', l: 'Recibida certificación registral' },
                            { v: 'subasta_solicitada', l: 'Subasta solicitada' },
                            { v: 'subasta_convocada', l: 'Subasta convocada' },
                            { v: 'subasta_en_curso', l: 'Subasta en curso' },
                            { v: 'subasta_celebrada', l: 'Subasta celebrada' },
                            { v: 'auto_adjudicacion', l: 'Auto de adjudicación' },
                            { v: 'adjudicacion', l: 'Adjudicación' },
                            { v: 'lanzamiento', l: 'Lanzamiento' },
                            { v: 'oposicion', l: 'Oposición' },
                            { v: 'apelacion', l: 'Apelación' },
                            { v: 'cerrado', l: 'Cerrado' },
                          ].map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                        </select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {Object.keys(fjScan.recognised || {}).length > 0 && (
              <details className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
                <summary className="cursor-pointer hover:underline">Ver {Object.keys(fjScan.recognised).length} valores ya reconocidos</summary>
                <ul className="mt-2 space-y-0.5">
                  {Object.entries(fjScan.recognised).map(([raw, canon]) => (
                    <li key={raw} className="flex items-center gap-2">
                      <span className="font-mono">{raw}</span>
                      <span>→</span>
                      <span className="px-1.5 py-0.5 rounded-full bg-emerald-100 text-emerald-700 font-medium">{canon}</span>
                    </li>
                  ))}
                </ul>
              </details>
            )}
            <div className="flex justify-between gap-2 pt-2">
              <button onClick={skipFjMapping} className="btn-secondary text-sm" data-testid="fj-mapper-skip-btn">
                Saltar mapeo (importar sin fase judicial)
              </button>
              <div className="flex gap-2">
                <button onClick={() => { setShowFjMapper(false); setFjScan(null); }} className="btn-secondary text-sm" data-testid="fj-mapper-cancel-btn">Cancelar</button>
                <button onClick={confirmFjMapping} className="btn-primary text-sm" data-testid="fj-mapper-confirm-btn">
                  Guardar y continuar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Step 3: Result */}
      {step === 3 && importResult && (
        <div className="card-base p-8 text-center">
          <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
            <svg className="w-7 h-7 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
          </div>
          <h2 className="heading-2 mb-2">Importacion completada</h2>
          <p className="body-text mb-6">{importResult.imported} de {importResult.total} activos importados</p>

          {/* Autofill summary — shown when the import enriched existing
              assets by filling empty columns from new Excel rows. */}
          {importResult.autofilled_fields > 0 && (
            <div className="mb-6 p-5 bg-emerald-50 rounded-lg border border-emerald-200 max-w-2xl mx-auto text-left" data-testid="autofill-summary">
              <p className="text-emerald-800 font-semibold mb-3 text-sm uppercase tracking-wide">
                Autocompletado de campos vacíos
              </p>
              <div className="grid grid-cols-2 gap-3 text-sm">
                <div className="flex justify-between">
                  <span className="text-slate-600">Activos enriquecidos</span>
                  <span className="font-bold text-emerald-700" data-testid="autofill-assets">
                    {importResult.autofilled_assets}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-600">Campos rellenados</span>
                  <span className="font-bold text-emerald-700" data-testid="autofill-fields">
                    {importResult.autofilled_fields}
                  </span>
                </div>
              </div>
              <p className="text-xs text-slate-500 mt-3">
                Solo se han rellenado columnas que estaban vacías en el activo existente. Los valores ya presentes no se han sobrescrito.
              </p>
              {importResult.autofilled_details && importResult.autofilled_details.length > 0 && (
                <details className="mt-3 group" data-testid="autofill-details-toggle">
                  <summary className="cursor-pointer text-sm text-emerald-700 font-medium select-none">
                    Ver los {importResult.autofilled_details.length} activos enriquecidos ▾
                  </summary>
                  <div className="mt-3 max-h-72 overflow-y-auto border border-emerald-200 rounded bg-white">
                    <table className="w-full text-xs">
                      <thead className="bg-emerald-100/60 sticky top-0">
                        <tr>
                          <th className="px-3 py-2 text-left font-semibold text-slate-700">NPL</th>
                          <th className="px-3 py-2 text-left font-semibold text-slate-700">Campos rellenados</th>
                        </tr>
                      </thead>
                      <tbody>
                        {importResult.autofilled_details.map((row) => (
                          <tr key={row.id} className="border-t border-emerald-100" data-testid={`autofill-row-${row.codigo_npl}`}>
                            <td className="px-3 py-2">
                              <a
                                href={`/activos/${row.id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:underline font-mono"
                              >
                                {row.codigo_npl || row.id.slice(0, 8)}
                              </a>
                            </td>
                            <td className="px-3 py-2 text-slate-700">
                              <span className="text-xs">{row.fields.length} · </span>
                              <span className="font-mono text-[11px] text-slate-500">{row.fields.join(', ')}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </details>
              )}
            </div>
          )}

          {/* Catastro enrichment summary */}
          {importResult.catastro && (importResult.catastro.consultados > 0 || importResult.catastro.pendientes > 0) && (
            <div className="mb-6 p-5 bg-blue-50 rounded-lg border border-blue-200 max-w-lg mx-auto text-left" data-testid="catastro-summary">
              <p className="text-blue-800 font-semibold mb-3 text-sm uppercase tracking-wide">Enriquecimiento desde Catastro</p>
              <div className="grid grid-cols-2 gap-3 text-sm">
                <div className="flex justify-between">
                  <span className="text-slate-600">Consultados</span>
                  <span className="font-bold text-slate-800" data-testid="catastro-consultados">{importResult.catastro.consultados}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-600">Metros completados</span>
                  <span className="font-bold text-emerald-600" data-testid="catastro-enriquecidos">{importResult.catastro.enriquecidos}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-600">No encontrados</span>
                  <span className="font-bold text-amber-600" data-testid="catastro-no-encontrados">{importResult.catastro.no_encontrados}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-600">Errores consulta</span>
                  <span className="font-bold text-red-500" data-testid="catastro-errores">{importResult.catastro.errores}</span>
                </div>
                {importResult.catastro.pendientes > 0 && (
                  <div className="flex justify-between col-span-2 pt-2 border-t border-blue-200">
                    <span className="text-slate-700 font-medium">Pendientes de enriquecer</span>
                    <span className="font-bold text-slate-900">{importResult.catastro.pendientes}</span>
                  </div>
                )}
              </div>
              {importResult.catastro.pendientes > 0 && (
                <div className="mt-4 pt-4 border-t border-blue-200">
                  <button onClick={runEnrichPending} disabled={enriching} className="btn-primary w-full text-sm" data-testid="enrich-pending-btn">
                    {enriching ? 'Enriqueciendo...' : `Enriquecer ${importResult.catastro.pendientes} pendientes ahora`}
                  </button>
                  {enrichProgress && (
                    <p className="text-xs text-slate-600 mt-2 text-center">
                      Procesados: {enrichProgress.processed} · Completados: <strong className="text-emerald-600">{enrichProgress.enriquecidos}</strong>
                      {enrichProgress.pendientes != null && ` · Quedan: ${enrichProgress.pendientes}`}
                    </p>
                  )}
                </div>
              )}
              <p className="text-xs text-slate-500 mt-3">Solo se consultan activos con referencia catastral y sin metros en el Excel. El enriquecimiento en lotes no tiene límite de tiempo.</p>
            </div>
          )}

          {importResult.errors?.length > 0 && (
            <div className="mb-6 p-4 bg-amber-50 rounded-lg border border-amber-200 text-left max-w-md mx-auto">
              <p className="text-amber-700 font-medium mb-2">Errores:</p>
              <ul className="text-sm text-amber-600 space-y-1">{importResult.errors.map((e, i) => <li key={i}>{e}</li>)}</ul>
            </div>
          )}
          <div className="flex justify-center gap-4">
            <button onClick={reset} className="btn-secondary" data-testid="import-another-btn">Importar otro</button>
            <button onClick={() => window.location.href = '/activos'} className="btn-primary" data-testid="view-assets-btn">Ver activos</button>
          </div>
        </div>
      )}

      {/* Preflight blocking modal — shown when >50% rows would land with
           critical fields missing and the user hasn't fixed it via the
           global % discount / tipo selector. They can still confirm to
           proceed; we just want to be sure they did it on purpose. */}
      {showPreflightModal && preflight && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)' }}
          data-testid="preflight-modal"
          onClick={() => setShowPreflightModal(false)}
        >
          <div
            className="card-base p-6 max-w-lg w-full shadow-2xl border-l-4 border-amber-500"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center gap-2 mb-3">
              <span className="text-amber-500 text-2xl">⚠️</span>
              <h3 className="heading-3 text-amber-900">¿Seguro que quieres importar así?</h3>
            </div>
            <p className="text-sm text-slate-700 mb-4">
              Más del <strong>50%</strong> de las {preflight.total_rows} filas tienen campos críticos vacíos y no has aplicado un valor global para resolverlo:
            </p>
            <ul className="space-y-2 mb-4">
              {preflight.total_rows > 0 && preflight.missing_precio_compra.count / preflight.total_rows > 0.5 && !descuentoDeudaPct && (
                <li className="text-sm flex items-start gap-2 p-2 bg-amber-50 rounded border border-amber-200">
                  <span>💰</span>
                  <span>
                    <strong>{preflight.missing_precio_compra.count}/{preflight.total_rows}</strong> sin precio de compra y sin <strong>% Descuento</strong> aplicado → todos esos quedarán a 0 €.
                  </span>
                </li>
              )}
              {preflight.total_rows > 0 && preflight.missing_tipo_operativo.count / preflight.total_rows > 0.5 && !tipoOperativo && (
                <li className="text-sm flex items-start gap-2 p-2 bg-amber-50 rounded border border-amber-200">
                  <span>🏷️</span>
                  <span>
                    <strong>{preflight.missing_tipo_operativo.count}/{preflight.total_rows}</strong> sin tipo de operación y sin <strong>tipo global</strong> seleccionado → quedarán sin clasificar.
                  </span>
                </li>
              )}
            </ul>
            <p className="text-xs text-slate-500 mb-5">
              Recomendación: vuelve atrás, rellena el campo "% Descuento sobre Deuda" o el "Tipo de operación" globales en la configuración, y vuelve a importar.
            </p>
            <div className="flex gap-2 justify-end">
              <button
                onClick={() => setShowPreflightModal(false)}
                className="btn-secondary text-sm"
                data-testid="preflight-modal-cancel"
              >
                Volver y corregir
              </button>
              <button
                onClick={() => {
                  setPreflightConfirmed(true);
                  setShowPreflightModal(false);
                  // Re-launch import with the confirmation flag set
                  setTimeout(() => handleImport(), 0);
                }}
                className="btn-primary text-sm bg-amber-600 hover:bg-amber-700 border-amber-600"
                data-testid="preflight-modal-confirm"
              >
                Importar de todos modos
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImporterPage;

// ---- Reconciliation panel (Step 2.5) ----
const RECONCILE_FIELD_LABELS = {
  direccion: 'Dirección',
  municipio: 'Municipio',
  provincia: 'Provincia',
  codigo_postal: 'CP',
  tipo_activo: 'Tipo inmueble',
  metros: 'Metros',
  precio_compra: 'Precio compra',
  valor_salida_base: 'Valor salida base',
  valor_referencia: 'Valor referencia',
  tasacion: 'Tasación',
  valor_adjudicacion: 'Valor adjudicación',
  deuda_total: 'Deuda total',
  deuda_reclamada: 'Deuda reclamada',
};

const ACTION_LABELS = {
  merge: 'Fusionar como deuda',
  new: 'Crear activo nuevo',
  skip: 'Saltar fila',
};

const fmt = (v) => {
  if (v === null || v === undefined || v === '') return '—';
  if (typeof v === 'number') return new Intl.NumberFormat('es-ES').format(v);
  return String(v);
};

const fmtDate = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('es-ES'); } catch { return iso; }
};

const ReconciliationPanel = ({ data, decisions, setDecisions, onBack, onConfirm, loading }) => {
  const [expanded, setExpanded] = React.useState({}); // {global_idx: bool}

  const setAction = (global_idx, action, existing_id) => {
    setDecisions(prev => ({
      ...prev,
      [global_idx]: { ...(prev[global_idx] || {}), action, existing_id, overrides: (prev[global_idx]?.overrides) || {} },
    }));
  };

  const setOverride = (global_idx, field, checked) => {
    setDecisions(prev => ({
      ...prev,
      [global_idx]: {
        ...(prev[global_idx] || {}),
        overrides: { ...((prev[global_idx]?.overrides) || {}), [field]: checked },
      },
    }));
  };

  const applyToAll = (action) => {
    const next = { ...decisions };
    for (const c of data.conflicts) {
      next[c.global_idx] = { action, existing_id: c.existing.id, overrides: (next[c.global_idx]?.overrides) || {} };
    }
    setDecisions(next);
  };

  const counts = React.useMemo(() => {
    let merge = 0, skip = 0, nuevo = 0;
    for (const c of data.conflicts) {
      const a = decisions[c.global_idx]?.action || 'merge';
      if (a === 'merge') merge++; else if (a === 'skip') skip++; else if (a === 'new') nuevo++;
    }
    return { merge, skip, nuevo, newRows: data.new_count };
  }, [decisions, data]);

  return (
    <div className="space-y-6" data-testid="reconcile-panel">
      {/* Header card */}
      <div className="card-base p-6 border-2 border-amber-300 bg-amber-50">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <h3 className="heading-3 text-amber-900 flex items-center gap-2">
              Reconciliación de duplicados
            </h3>
            <p className="text-sm text-amber-800 mt-1">
              Se han detectado <strong>{data.duplicate_count}</strong> filas cuya referencia catastral ya existe en la base de datos.
              Decide qué hacer con cada una. {data.new_count} filas sin coincidencia se crearán como activos nuevos.
              {(data.auto_skipped || 0) > 0 && (
                <>
                  {' '}<span className="text-slate-600">·</span> <strong>{data.auto_skipped}</strong> filas ya existentes se han saltado automáticamente
                  {data.auto_skipped_no_diff > 0 && data.auto_skipped_catastro_only > 0 && (
                    <> ({data.auto_skipped_no_diff} sin cambios, {data.auto_skipped_catastro_only} solo cambios de catastro)</>
                  )}
                  {data.auto_skipped_no_diff > 0 && data.auto_skipped_catastro_only === 0 && (
                    <> (sin cambios frente a la BD)</>
                  )}
                  {data.auto_skipped_no_diff === 0 && data.auto_skipped_catastro_only > 0 && (
                    <> (solo cambios de dirección, municipio o m² — datos de catastro)</>
                  )}
                  .
                </>
              )}
            </p>
          </div>
          <div className="flex gap-2 shrink-0">
            <button onClick={() => applyToAll('merge')} className="btn-secondary text-xs">Todas: Fusionar</button>
            <button onClick={() => applyToAll('new')} className="btn-secondary text-xs">Todas: Crear nuevo</button>
            <button onClick={() => applyToAll('skip')} className="btn-secondary text-xs">Todas: Saltar</button>
          </div>
        </div>
        <div className="flex gap-6 mt-4 text-sm flex-wrap">
          <div><span className="text-slate-500">Se crearán</span>: <strong>{counts.newRows + counts.nuevo}</strong> activos</div>
          <div><span className="text-slate-500">Se fusionarán como deuda</span>: <strong>{counts.merge}</strong></div>
          <div><span className="text-slate-500">Se saltarán</span>: <strong>{counts.skip}</strong></div>
        </div>
      </div>

      {/* Conflicts list */}
      <div className="space-y-3">
        {data.conflicts.map((c) => {
          const dec = decisions[c.global_idx] || { action: 'merge' };
          const isExpanded = !!expanded[c.global_idx];
          return (
            <div key={c.global_idx} className="card-base p-4" data-testid={`conflict-row-${c.global_idx}`}>
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-xs font-mono text-slate-500">{c.sheet_name} · fila {c.row_idx + 2}</span>
                    <span className="font-mono text-sm font-semibold">{c.referencia_catastral}</span>
                    <span className="badge-blue">Activo existente: {c.existing.codigo_npl}</span>
                    {c.existing.num_deudas > 0 && (
                      <span className="text-xs text-slate-500">({c.existing.num_deudas} deuda{c.existing.num_deudas !== 1 ? 's' : ''} actuales)</span>
                    )}
                    <span className="text-xs text-slate-400">· importado {fmtDate(c.existing.created_at)}</span>
                  </div>
                </div>
                <div className="flex gap-1 shrink-0">
                  {['merge', 'new', 'skip'].map(a => (
                    <button
                      key={a}
                      onClick={() => setAction(c.global_idx, a, c.existing.id)}
                      className={`px-3 py-1.5 text-xs font-medium rounded-lg border transition-colors ${
                        dec.action === a
                          ? (a === 'skip' ? 'bg-slate-600 text-white border-slate-600' : a === 'new' ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-blue-600 text-white border-blue-600')
                          : 'bg-white text-slate-600 border-slate-200 hover:border-slate-300'
                      }`}
                      data-testid={`action-${a}-${c.global_idx}`}
                    >{ACTION_LABELS[a]}</button>
                  ))}
                </div>
              </div>

              {/* Expand button */}
              <div className="mt-3 flex items-center gap-3">
                <button
                  onClick={() => setExpanded(prev => ({ ...prev, [c.global_idx]: !prev[c.global_idx] }))}
                  className="text-xs text-blue-600 hover:text-blue-700 font-medium"
                >
                  {isExpanded ? '▾ Ocultar comparativa' : `▸ Ver comparativa (${c.fields_diff.length} campos difieren)`}
                </button>
                {dec.action === 'merge' && Object.values(dec.overrides || {}).some(Boolean) && (
                  <span className="text-xs text-amber-600">
                    {Object.values(dec.overrides || {}).filter(Boolean).length} campo(s) a sobrescribir
                  </span>
                )}
              </div>

              {isExpanded && (
                <div className="mt-4 overflow-x-auto">
                  <table className="min-w-full text-sm border-t border-slate-200">
                    <thead>
                      <tr className="text-left text-xs uppercase tracking-wide text-slate-500">
                        <th className="py-2 pr-4 w-36">Campo</th>
                        <th className="py-2 pr-4">Existente ({c.existing.codigo_npl})</th>
                        <th className="py-2 pr-4">Nuevo (Excel)</th>
                        {dec.action === 'merge' && <th className="py-2 pr-4 w-32 text-center">Sobrescribir</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(RECONCILE_FIELD_LABELS).map(f => {
                        const ev = c.existing[f];
                        const iv = c.incoming[f];
                        const differs = c.fields_diff.includes(f);
                        const empty = (ev === null || ev === undefined || ev === '') && (iv === null || iv === undefined || iv === '');
                        if (empty) return null;
                        return (
                          <tr key={f} className={differs ? 'border-b border-slate-100 bg-amber-50/30' : 'border-b border-slate-100'}>
                            <td className="py-2 pr-4 text-slate-600">{RECONCILE_FIELD_LABELS[f]}</td>
                            <td className="py-2 pr-4">{fmt(ev)}</td>
                            <td className={`py-2 pr-4 ${differs ? 'font-medium text-amber-900' : ''}`}>{fmt(iv)}</td>
                            {dec.action === 'merge' && (
                              <td className="py-2 pr-4 text-center">
                                {differs && iv !== null && iv !== undefined && iv !== '' ? (
                                  <input
                                    type="checkbox"
                                    checked={!!(dec.overrides || {})[f]}
                                    onChange={(e) => setOverride(c.global_idx, f, e.target.checked)}
                                    className="w-4 h-4 accent-blue-600"
                                    data-testid={`override-${f}-${c.global_idx}`}
                                  />
                                ) : (
                                  <span className="text-slate-300">—</span>
                                )}
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <p className="text-xs text-slate-500 mt-2">
                    Si fusionas, la deuda de la fila nueva se añade como un ítem más a <strong>{c.existing.codigo_npl}</strong>. Los campos marcados arriba sobrescribirán los valores actuales del activo maestro.
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Footer actions */}
      <div className="card-base p-4 flex items-center justify-between sticky bottom-0 bg-white">
        <button onClick={onBack} className="btn-secondary" data-testid="reconcile-back-btn">← Volver al mapeo</button>
        <div className="flex gap-3 items-center">
          <span className="text-sm text-slate-500">{counts.newRows + counts.nuevo} nuevos · {counts.merge} fusiones · {counts.skip} saltos</span>
          <button onClick={onConfirm} disabled={loading} className="btn-primary" data-testid="reconcile-confirm-btn">
            {loading ? 'Importando...' : 'Confirmar e importar'}
          </button>
        </div>
      </div>
    </div>
  );
};
